/** Shared report table classes — every tabular block composes these. */
export const tableStyles = {
  table: 'w-full border-collapse text-sm',
  headRow: 'border-b-2 border-[var(--report-accent)]/40',
  th: 'py-1.5 pr-4 text-left text-xs font-semibold uppercase tracking-wide text-muted-foreground',
  thNum: 'py-1.5 pl-4 text-right text-xs font-semibold uppercase tracking-wide text-muted-foreground',
  row: 'border-b border-border/60',
  cell: 'py-1.5 pr-4 align-top',
  cellNum: 'py-1.5 pl-4 text-right align-top tabular-nums',
  groupTitle: 'mb-1.5 mt-4 text-sm font-semibold text-foreground',
} as const
